package de.ohhhmhhh.frontend.admin.ui.screens.revocation

import de.ohhhmhhh.backend.models.model.revocation.RevocationContractTypeEntity
import de.ohhhmhhh.backend.models.model.revocation.RevocationFilterEntity
import de.ohhhmhhh.backend.models.model.revocation.RevocationStateEntity
import de.ohhhmhhh.backend.models.model.shared.PageRequestEntity
import de.ohhhmhhh.backend.sdk.revocations.RevocationService
import de.ohhhmhhh.frontend.admin.mvvm.BaseViewModel

class RevocationListViewModel(
    private val service: RevocationService
) : BaseViewModel<RevocationListState>(RevocationListState()) {
    private companion object {
        const val PAGE_SIZE = 30
    }

    init {
        loadRevocations()
    }

    fun setSearch(search: String?) {
        update { copy(search = search) }
        loadRevocations()
    }

    fun setContractType(contractType: RevocationContractTypeEntity?) {
        update { copy(contractType = contractType) }
        loadRevocations()
    }

    fun setState(state: RevocationStateEntity?) {
        update { copy(state = state) }
        loadRevocations()
    }

    fun setPage(page: Int) {
        update { copy(page = page) }
        loadRevocations()
    }

    fun reset() {
        update {
            copy(
                items = emptyList(),
                search = null,
                contractType = null,
                state = null,
                page = 0,
                pageCount = 0,
                resultCount = 0
            )
        }
        loadRevocations()
    }

    fun loadRevocations() {
        val state = value()
        val request = PageRequestEntity(
            filter = RevocationFilterEntity(
                search = state.search,
                contractType = state.contractType,
                state = state.state
            ),
            pageIndex = state.page,
            pageSize = PAGE_SIZE
        )
        launch {
            val result = service.getAll(request)
            update {
                copy(
                    items = result.items,
                    page = result.index,
                    pageCount = result.count,
                    resultCount = result.resultCount
                )
            }
        }
    }

    fun updateState(id: String, state: RevocationStateEntity) {
        val updated = value().items.first { it.id == id }.copy(state = state)
        launch {
            val result = service.update(updated)
            update {
                copy(
                    items = items.map { if (it.id == id) result else it }
                )
            }
        }
    }
}